import { Component, inject, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';
import { NAV_ITEMS } from '../../../core/config/nav.config';
import { AppIconComponent } from '../app-icon/app-icon.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, AppIconComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private readonly authService = inject(AuthService);

  readonly isOpen = input(false);
  readonly closed = output<void>();

  readonly navItems = NAV_ITEMS;
  readonly fullName = this.authService.fullName;
  readonly initials = this.authService.initials;

  onNavClick(): void {
    this.closed.emit();
  }

  onSignOut(): void {
    this.authService.logout();
  }
}
